import script from "./ImpressumIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ImpressumIndex.vue?vue&type=script&setup=true&lang=js"

import "./ImpressumIndex.vue?vue&type=style&index=0&id=2645073b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2645073b"]])

export default __exports__